import {AfterViewInit, Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appForceReadonly]'
})
export class ForceReadonlyDirective implements AfterViewInit {

  @Input('appForceReadonly') enabled: boolean = true;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngAfterViewInit() {
    setTimeout(() => this.applyReadonly());
  }

  @HostListener('focus')
  @HostListener('click')
  onInteraction() {
    // Re-apply whenever ngx-bootstrap re-renders the input
    this.applyReadonly();
  }

  private applyReadonly() {
    if (this.enabled === true) {
      // Keep cursor working but block typing
      this.el.nativeElement.setAttribute('readonly', 'readonly');
    } else {
      // Fully restore editable input
      this.el.nativeElement.removeAttribute('readonly');
    }
  }
}
